export const getDesktopDevice = async (apiCall, scopeId, deviceId) => {
  try {
    const resp = await apiCall(
      `/desktop/get?scope=${scopeId}&device=${deviceId}`,
      "GET"
    );
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const registerDesktopDevice = async (apiCall, deviceData) => {
  try {
    const resp = await apiCall(`/desktop/save`, "POST", deviceData);
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const deleteDesktopDevice = async (apiCall, scopeId, deviceId) => {
  try {
    const resp = await apiCall(`/desktop/delete`, "POST", {
      scopeId,
      deviceId,
    });
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};
